import {
    Box,
    Grid2,
} from '@mui/material'
import React, { useEffect } from 'react'
import LatestEventCard from '../../shared/components/LatestEventCard';
import CustomDivider from '../../shared/utils/CustomDivider';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import { useEvents } from '../../assets/api/useGetApi';
import { NavigateButton } from '../../shared/utils/CustomButton';
import { useNavigate } from 'react-router-dom';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';

const LatestEvent = () => {
    const navigate = useNavigate()
    const { data, fetchNextPage, hasNextPage, isLoading } = useEvents();
    useEffect(() => {
        if (hasNextPage) {
            fetchNextPage();
        }
    }, [hasNextPage, fetchNextPage]);
    const events = data?.pages.flatMap(page => page.data) || [];

    return (
        <Box>

            <HorizontalScroll heading={"Stay updated on our latest events, workshops, and special activities"} subheading={"Exciting Events & Happenings – Don’t Miss Out!"} size={3}>
                {!isLoading && (
                    events?.map((item, index) => (
                        <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}>
                            <LatestEventCard item={item} />

                        </Grid2>
                    ))
                )}
                {
                    isLoading && [...Array(6)].map((_, index) => (
                        <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                }
            </HorizontalScroll>
            <CustomDivider orientation='horizontal' size={"30px"} />
            <NavigateButton onClick={() => navigate('/Events')} />

        </Box>
    )
}

export default LatestEvent